export default __webpack_public_path__ + "static/media/sector-clean.c4a84539.png";